import clsx from "clsx";
import { DetailTable } from "./DetailTable";
import { useDealStructureData } from "../hooks/useDealStructureData";
import { JumpToSection } from "./JumpToSection";
import { useFlags } from "@/utils/flagsmith/useFlags";
import { ExpandableMarkdown } from "./ExpandableMarkdown";
import { LabelLLM } from "./LabelLLM";

export function DealStructure({ opportunityId }: { opportunityId?: string }) {
    const {
        productData,
        economicsData,
        termsConditionsData,
        covenantsColorized,
        isLoading,
    } = useDealStructureData({ opportunityId });
    const flags = useFlags();
    const showDataSources = flags.enabled("show-data-sources");

    return (
        <>
            <div className="space-y-12">
                <DetailTable
                    title="Product"
                    data={productData}
                    isLoading={isLoading}
                />
                <DetailTable
                    title="Economics"
                    data={economicsData}
                    isLoading={isLoading}
                />
                <DetailTable
                    title="Terms & Conditions"
                    data={termsConditionsData}
                    isLoading={isLoading}
                />
            </div>
            <div className="space-y-6">
                <div className="mt-6">
                    <h3 className="heading-m mb-3">Covenants</h3>
                    <div>
                        <div className="mb-2">
                            <ExpandableMarkdown
                                text={covenantsColorized.value}
                                maxLength={1800}
                            />
                        </div>
                        {showDataSources && covenantsColorized.source && (
                            <span
                                className={clsx(
                                    "mt-1 text-[9px] font-medium tracking-wide",
                                    covenantsColorized.sourceClassName,
                                )}
                            >
                                {covenantsColorized.source}
                            </span>
                        )}
                        <LabelLLM />
                    </div>
                </div>
            </div>
            <JumpToSection
                targetSection="capital-and-deal-structure"
                label="Jump to Capital & Deal Structure"
            />
        </>
    );
}
